import itemTypeEditComponent from './item_type.edit.component';

let itemTypeEditModule = angular.module('itemTypeEdit', [
])

.component('itemTypeEdit', itemTypeEditComponent)

.name;

export default itemTypeEditModule;


// WEBPACK FOOTER //
// ./client/app/components/item_type/edit/index.js